<div class="resource-route-map-container">
  <!-- Loading indicator -->
  @if (loading) {
    <div class="loading-overlay">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <!-- Date navigation - only shown when not in dialog mode -->
  @if (!isDialog) {
    <div class="date-navigation">
      <div class="date-controls">
        <button mat-icon-button (click)="goToPreviousDay()" aria-label="Previous day">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="current-date">
          {{ currentDate | amDateFormat: 'DD MMM YYYY' }}
        </div>
        <button mat-icon-button (click)="goToNextDay()" aria-label="Next day">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- Map and directions container -->
  <div class="map-panel">
    <!-- Map container -->
    <div class="map" #mapElement></div>

    <!-- Directions panel -->
    <div class="directions-panel">
      @if (resourceRouteDetails.length === 0 && !loading) {
        <div class="no-routes">
          No routes found for this date.
        </div>
      }
      <div class="directions-accordion">
        @for (detail of resourceRouteDetails; track detail) {
          <mat-accordion>
            <mat-expansion-panel [ngClass]="'ticket-expansion-panel'"
              [expanded]="selectedTicket?.id === detail.ticket.id">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <div [style.background-color]="detail.background"
                  [style.foreground-color]="detail.foreground" class="traffic-light"></div>
                  {{ detail.ticket.ticketStatus }} -
                  {{ detail.ticket.visit?.job?.externalJobReference }}
                </mat-panel-title>
                <mat-panel-description>
                  @if (detail.ticket.enrouteTime) {
                    Leave {{ detail.ticket.enrouteTime | amDateFormat: 'HH:mm' }}
                  }
                  @if (detail.ticket.arrivedTime) {
                    / Arrive {{ detail.ticket.arrivedTime | amDateFormat: 'HH:mm' }}
                  }
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="directions-content">
                <h4>Directions</h4>
                @if (detail.route) {
                  <div class="route-summary">
                    <div>Total Distance: {{ detail.route.distance | number:'1.0-1' }} m</div>
                    <div>Estimated Time: {{ detail.route.time | number:'1.0-0' }} s</div>
                  </div>
                  <mat-card class="instructions-card">
                    <mat-card-content>
                      <div class="instruction-list">
                        @for (instruction of detail.route.instructions; track instruction) {
                          <div
                            class="instruction-item">
                            <div class="instruction-distance">{{ instruction.distance |
                            number:'1.0-0' }} m</div>
                            <div class="instruction-text">{{ instruction.signDescription }} {{
                            instruction.name }}</div>
                            <div class="instruction-time">({{ instruction.time | number:'1.0-0'
                            }} s)</div>
                          </div>
                        }
                      </div>
                    </mat-card-content>
                  </mat-card>
                }
                @if (!detail.route) {
                  <div class="no-route-data">
                    Route information is loading...
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </div>
    </div>
  </div>
</div>
